import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Catalog } from "@modules/catalogs/types";
import { CatalogFormValues } from "@modules/catalogs/validations";

import { createCatalogService } from "./service";
import { UseCreateCatalogMutationOptions } from "./types";

export function useCreateCatalogMutation(
  options?: UseCreateCatalogMutationOptions
) {
  const { open } = useNotification();

  return useMutation<Catalog, ApiError, CatalogFormValues>({
    mutationFn: createCatalogService,
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
